import { render, staticRenderFns } from "./CamDashboardComponent.vue?vue&type=template&id=555bf78c&"
import script from "./CamDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./CamDashboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports